import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

export const useStore = defineStore('media', {
    state: () => ({
        speakCountVal: useStorage("speakCountVal", 1),
        sentenceBlankVal: useStorage("sentenceBlankVal", 0),
        speedVal: useStorage("speedVal", 1)
    }),
})